<div class="begin-course-modal">
  <h2 mat-dialog-title>Begin Course for {{ data.employee?.employee_name }}</h2>
  
  <mat-dialog-content>
    <p class="instruction-text">Choose a course for the employee to begin training</p>
    
    <div class="courses-list">
      <div 
        *ngFor="let course of courses" 
        class="course-option"
        [class.selected]="selectedCourse?.id === course.id"
        [class.completed]="isCourseCompleted(course)"
        (click)="selectCourse(course)">
        <div class="course-option-content">
          <h4 class="course-option-name">{{ course.name }}</h4>
          <p class="course-option-description" *ngIf="course.description" [innerHTML]="course.description">
          </p>
          <p class="course-option-duration">Duration: {{ course.duration_days }} days</p>
        </div>
        <button 
          *ngIf="!isCourseCompleted(course)"
          mat-raised-button
          class="select-button"
          (click)="selectCourse(course); enroll(course); $event.stopPropagation()"
          [disabled]="loading">
          {{ loading && selectedCourse?.id === course.id ? 'Enrolling...' : 'Select' }}
        </button>
        <span *ngIf="isCourseCompleted(course)" class="completed-label">Completed</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
